import {Action, createReducer, on} from '@ngrx/store';
import {UIState} from './ui-state';
import {uiMapChangeChacra} from './ui.actions';

export const initialState: UIState = {
  map: {
    chacra: null
  }
};

const reducer = createReducer(
  initialState,
  on(uiMapChangeChacra, (state, payload) => ({
    ...state,
    map: {
      ...state.map,
      chacra: payload.chacra
    }
  })),
);

export function uiReducer(state: UIState | undefined, action: Action): UIState {
  return reducer(state, action);
}
